import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAppInstance } from '@helios/auth-firebase-web';

export interface UploadParams {
  orgId: string;
  patientId: string;
  clinicId?: string | null;
  appointmentId?: string | null;
  queueId?: string | null;
  file: File;
  /** ID pre-generated by the caller (used as folder name in Storage). */
  fileId: string;
}

export interface UploadResult {
  downloadUrl: string;
  storagePath: string;
  filename: string;
  mimeType: string;
}

/**
 * Upload a file to Firebase Storage under the patient's folder.
 * Path: orgs/{orgId}/patients/{patientId}/files/{fileId}/{originalFilename}
 */
export async function uploadToStorage(params: UploadParams): Promise<UploadResult> {
  const { orgId, patientId, file, fileId } = params;

  const storagePath = `orgs/${orgId}/patients/${patientId}/files/${fileId}/${file.name}`;
  const storage = getStorage(getAppInstance());
  const storageRef = ref(storage, storagePath);

  await uploadBytes(storageRef, file, {
    contentType: file.type || 'application/octet-stream',
  });

  const downloadUrl = await getDownloadURL(storageRef);

  return {
    downloadUrl,
    storagePath,
    filename: file.name,
    mimeType: file.type || 'application/octet-stream',
  };
}
